// extracted by mini-css-extract-plugin
module.exports = {"gradient-button":"gradient-button_gradient-button__jZM5V"};